//Diese Datei ist gedacht für globale String-Konstanten, die sich zur Compilezeit irgendwann ändern können
//IDs bitte in die entsprechende Datei unter src/utils

export const INTERNAL_ATTRIBUTE_NAME = "data-evo";
export const CURRENT_LOCALE = "de";
